import React from 'react';
import { EuiGlobalToastList } from '@elastic/eui';
import { alertClear, selectToasts } from './alert.slice';
import { useDispatch, useSelector } from 'react-redux';

export const GlobalAlert = () => {
  const dispatch = useDispatch();
  const toasts = useSelector(selectToasts);
  const removeToast = (removedToast) => {
    dispatch(alertClear(removedToast));
  };

  return <EuiGlobalToastList toasts={toasts} dismissToast={removeToast} toastLifeTimeMs={6000} />;
};
